import React, {Fragment} from 'react'
import {InputText, SwitchButtons, ThinTitle, Title} from '../../Presentational'
import styled from 'styled-components'
import i18n from '../../../Utils/I18nUtil'
import variables from '../../../../config/variables'
import Button from '../../Presentational/Atoms/Button'
import PasswordGenerator from '../Organisms/PasswordGenerator'
import Label from '../../Presentational/Atoms/Label'
import md5 from 'md5'

class WidgetBuilder extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            showExpertSettings: true,
            headlineColor: '#0b5f99',
            optionsColor: '#0b5f99',
            titleColor: '#36a1c9',
            buttonBackgroundColor: '#36a1c9',
            buttonTextColor: '#ffffff',
            backgroundColor: '#ffffff',
            borderColor: '#d9e2e9',
            generatorProps: {},
            widgetCode: '',
            publisherId: md5(Date.now()).substring(0,10),
            embedded: true,
            borderWidth: '1px',
        }
    }

    componentDidMount = () => this.generateWidget()

    generateWidget = () => {
        let stateSnapshot = JSON.parse(JSON.stringify(this.state))
        delete(stateSnapshot.generatorProps)

        const {
            showExpertSettings,
            optionsColor,
            headlineColor,
            titleColor,
            buttonBackgroundColor,
            buttonTextColor,
            borderColor,
            publisherId,
            embedded,
            backgroundColor,
            borderWidth,
        } = this.state

        const widgetCode = `<div id="pw-gen-widget" data-show-expert-settings="${showExpertSettings}" data-options-color="${optionsColor}" data-title-color="${titleColor}" data-button-background-color="${buttonBackgroundColor}" data-button-text-color="${buttonTextColor}" data-headline-color="${headlineColor}" data-border-color="${borderColor}" data-border-width="${borderWidth}" data-background-color="${backgroundColor}" data-embedded="${embedded}" data-publisher-id="${publisherId}"></div><script async src="${variables.widgetUrl}"></script>`

        this.setState({
            generatorProps: stateSnapshot,
            widgetCode: widgetCode,
        })
    }

    onChange = (key, value) => {
        let stateObject = {}
        stateObject[key] = value
        this.setState(stateObject)
    }

    render() {
        const {
            showExpertSettings,
            headlineColor,
            optionsColor,
            titleColor,
            buttonBackgroundColor,
            buttonTextColor,
            borderColor,
            widgetCode,
            generatorProps,
        } = this.state

        const color = '#0b5f99'

        return (
            <Fragment>
                <Title align={'center'} padding={'10px 0'}>
                    {i18n('builder.title')}
                </Title>
                <Container>
                    <Border>
                        <First>
                            <ThinTitle color={'#36a1c9'} margin={'0 0 10px 0'}>
                                {i18n('form.label.title_generate_widget')}
                            </ThinTitle>
                            <SwitchButtons
                                trueLabel={'form.builder.label.expert_settings_true'}
                                falseLabel={'form.builder.label.expert_settings_false'}
                                value={showExpertSettings}
                                color={'#36a1c9'}
                                label={i18n('form.label.show_expert_settings')}
                                onChange={value => this.onChange('showExpertSettings', value)}/>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.headline_color'}
                                    id={'builder-headline-color-input'}
                                    value={headlineColor}
                                    color={color}
                                    onChange={event => this.onChange('headlineColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.title_color'}
                                    id={'builder-title-color-input'}
                                    value={titleColor}
                                    color={color}
                                    onChange={event => this.onChange('titleColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.options_color'}
                                    id={'builder-title-and-options-color-input'}
                                    value={optionsColor}
                                    color={color}
                                    onChange={event => this.onChange('optionsColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.border_color'}
                                    value={borderColor}
                                    id={'builder-title-and-options-color'}
                                    color={color}
                                    onChange={event => this.onChange('borderColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.button_text_color'}
                                    id={'builder-button-text-color-input'}
                                    value={buttonTextColor}
                                    color={color}
                                    onChange={event => this.onChange('buttonTextColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            <InputWrapper>
                                <InputText
                                    label={'form.builder.label.button_background_color'}
                                    id={'builder-button-background-color-input'}
                                    value={buttonBackgroundColor}
                                    color={color}
                                    onChange={event => this.onChange('buttonBackgroundColor', event.currentTarget.value)}/>
                            </InputWrapper>
                            {/*<InputWrapper>*/}
                                {/*<InputText*/}
                                    {/*label={'form.builder.label.background_color'}*/}
                                    {/*id={'builder-title-and-options-color'}*/}
                                    {/*value={backgroundColor}*/}
                                    {/*color={color}*/}
                                    {/*onChange={event => this.onChange('backgroundColor', event.currentTarget.value)}/>*/}
                            {/*</InputWrapper>*/}
                            <ButtonWrapper>
                                <Button
                                    buttonStyle={'fullWidth'}
                                    label={i18n('form.button.label.generate_widget_code')}
                                    backgroundColor={'#36a1c9'}
                                    onClick={this.generateWidget}/>
                            </ButtonWrapper>
                        </First>
                        <Second>
                            <ThinTitle color={'#36a1c9'} margin={'0 0 10px 0'}>
                                {i18n('form.label.copy_widget_code')}
                            </ThinTitle>
                            <LabelWrapper>
                                <Label color={color}>
                                    {i18n('form.label.embed_code_area')}
                                </Label>
                            </LabelWrapper>
                            <Textarea
                                readonly={true}
                                onClick={event => event.currentTarget.select()}
                                value={widgetCode}/>
                        </Second>
                    </Border>
                </Container>
                <Title align={'center'} padding={'10px 0'}>
                    {i18n('builder.preview_title')}
                </Title>
                <PreviewContainer>
                    <PasswordGenerator {...generatorProps} observerActive={false}/>
                </PreviewContainer>
            </Fragment>
        )
    }
}

WidgetBuilder.propTypes = {}

export default WidgetBuilder

const Container = styled.div`
    background-color: transparent;
    position: relative;
`

const Border = styled.div`
    border-radius: 5px;
    border: 1px solid ${props => props.color
    ? props.color
    : '#d9e2e9'};
    background-color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row;
    }
`

const First = styled.div`
    @media (min-width: 768px) {
        padding-right: 10px;
        width: 50%;
    }
`

const ButtonWrapper = styled.div`
    padding-top: 20px;
`

const Second = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        margin-top: 0;
        width: 50%;
        padding-left: 10px;
    }
`

const InputWrapper = styled.div`
    margin-top: 20px;
    @media (min-width: 768px) {
        width: 50%;
        display: inline-block;
        &:nth-child(odd) > div {
            padding-right: 10px;
        }
        &:nth-child(even) > div {
            padding-left: 10px;
        }
    }
`

const Textarea = styled.textarea`
    width: 100%;
    border-radius: 5px;
    border: 1px solid #d9e2e9};
    box-sizing: border-box;
    flex: 1;
    resize: none;
    font-size: 18px;
    font-weight: 200;
    outline: 0;
    color: #5555555;
    padding: 10px;
    min-height: 350px;
    font-family: 'Open Sans', sans-serif;
    transition: border .5s ease, box-shadow 0.5s ease;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.02), inset 0 1px 1px rgba(0,0,0,0.06), 0px 0px 3px 1px rgba(0,0,0,0);
    &:focus {
        box-shadow: inset 0 1px 2px rgba(0,0,0,0), inset 0 1px 1px rgba(0,0,0,0), 0px 0px 5px 1px rgba(11, 95, 153,0.15);
    }
`

const LabelWrapper = styled.div`
    padding: 5px 0;
`

const PreviewContainer = styled.div`
    max-width: 750px;
    margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Container/Templates/WidgetBuilder.jsx